var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38448 0.0198059C1.06966 0.0198059 0 1.08831 0 2.40167C0 3.71561 1.06966 4.78452 2.38448 4.78452C3.69825 4.78452 4.76704 3.71555 4.76704 2.40167C4.7671 1.08831 3.69825 0.0198059 2.38448 0.0198059ZM4.18994 5.79077H0.57641C0.416035 5.79077 0.286087 5.92078 0.286087 6.08109V17.6898C0.286087 17.8502 0.416035 17.9801 0.57641 17.9801H4.18994C4.35031 17.9801 4.48026 17.8502 4.48026 17.6898V6.08109C4.48026 5.92078 4.35031 5.79077 4.18994 5.79077ZM10.2063 6.83507C10.857 6.12616 11.9299 5.50226 13.3812 5.50226C17.4512 5.50226 18 8.44433 18 11.3223V17.6899C18 17.8503 17.87 17.9802 17.7097 17.9802H14.1027C13.9423 17.9802 13.8124 17.8503 13.8124 17.6899V12.0458C13.8124 10.4655 13.6956 9.25671 12.2262 9.25671C10.877 9.25671 10.3513 10.0107 10.3513 11.9462V17.6898C10.3513 17.8502 10.2214 17.9801 10.061 17.9801H6.45538C6.295 17.9801 6.16505 17.8502 6.16505 17.6898V6.0811C6.16505 5.92079 6.295 5.79078 6.45538 5.79078H9.91596C10.0763 5.79078 10.2063 5.92079 10.2063 6.0811V6.83507Z",
    fill: "#00A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.ae3bb3a53cf8df1b1fd4197ef34cc04d.svg";
export { ForwardRef as ReactComponent };